// qiankun/config.js
// 这里用函数的方式，方便初始化的时候可以设置一些默认参数传进来，例如token等，
// 用于下发给微应用
export const getQiankunConfig = (props = {}) => {
  return {
    subApps: [
      {
        name: "vue3-demo", // 子应用名称，建议跟package.json一致
        entry: "//localhost:8081/", // 子应用入口，本地环境下指定端口
        container: "#sub-container", // 挂载子应用的dom
        activeRule: "/risk-app", // 路由匹配规则
        props, // 主应用与子应用通信传值
      },
    ],
  };
};
